export const TEXTS = {
  GROUP_CORRECT:
    'Группа работает корректно, видеоволны воспроизводятся синхронно, согласно длительности файлов в мастер-видеоволне',

  GROUP_WITH_ERROR: 'Ошибка синхронного воспроизведения',
  RENAME: 'Переименовать',
  REMOVE: 'Удалить',
  VIDEO_STREAM_INFO_FALLBACK: 'Мастер-видеоволна отсутствует',
  VIDEO_STREAM_INFO_TITLE: 'Мастер-видеоволна',
  POINTS_LIST_TITLE: 'Адреса',
  CHANGE: 'Сменить',
  CHANGE_POINTS_LIST: 'Изменить',
  FILE_FORMS: ['файл', 'файла', 'файлов'],
  VIDEO_STREAM_FALLBACK: 'Видеоволна отсутствует',
};
